export { CallesService } from "./Servicios/calles.service";
export { LocalidadesService } from "./Servicios/localidades.service";
export { PadronService } from "./Servicios/padron.service";
export { TiposDeDocumentosService } from "./Servicios/tipos-de-documentos.service";
export { UtilidadesService } from "./Servicios/utilidades.service";